export interface BreadcrumbItem {
    text: string;
    href?: string;
}

export const useBreadcrumbs = () => {
    const crumbs = useState<BreadcrumbItem[]>("breadcrumbs", () => []);
    return { crumbs };
};
